Customer.Reports ||= {}

class Customer.Reports.DashboardView extends Backbone.View
  template: JST['backbone/templates/customer/reports/dashboard']
  className: 'row-fluid reports'

  events:
    'change #from': 'onChangeFilter'
    'change #to': 'onChangeFilter'
    'change #special_filters select': 'onChangeFilter'
    'change #timezone_selector' : 'onChangeFilter'
    'change #report': 'onChangeReport'
    'click #filter': 'filter'
    'click #export': 'download'
    'click #export-confirm': 'exportConfirm'
    'click #with-work-calendar': 'activateWorkCalendar'
    'click #without-work-calendar': 'deactivateWorkCalendar'
    'click #with-profile-attributes': 'activateProfileAttributes'
    'click #without-profile-attributes': 'deactivateProfileAttributes'

  initialize: (@options = {}) ->
    @reports = @options.reports
    @groups = @options.groups
    @subtypes = @options.subtypes
    @operators = @options.operators
    @teams = @options.teams
    @output_format_definition = new Customer.Reports.ReportOutputFormatDefinition()
    @reportsWithOperatorFilter = @options.reportsWithOperatorFilter or []
    @specialReportKeys = @options.specialReportKeys or []
    @reportsWithPeriodSelector = @options.reportsWithPeriodSelector or []
    @reportsWithTeamsFilter = @options.reportsWithTeamsFilter or []
    @reportsWithGeneralActivityTeam = @options.reportsWithGeneralActivityTeam or []
    @reportsWithRangeSelector = @options.reportsWithRangeSelector or []
    @reportsWithWorkCalendarCheck = @options.reportsWithWorkCalendarCheck or []
    @reportsWithProfileAttributesCheck = @options.reportsWithProfileAttributesCheck or []
    @reportsWithTimeSelector = @options.reportsWithTimeSelector or []
    @workCalendar = false
    @profileAttributes = false

    @teamSelectorView = new Customer.Views.Reports.TeamSelectorView(
      teams: @teams, hasGeneralActivityTeam: @_hasGeneralActivityTeam()
    )

  onChangeReport: (event) =>
    @_toggleSpecificReportOptions()
    @onChangeFilter(event)

  _toggleSpecificReportOptions: ->
    @$el.find('#filter').toggle(@_isReportWithFilter())
    @$el.find('#special_filters').toggle(@_isSpecialReport())
    @$el.find('#operators-filter-container').toggleClass('d-none', !@_hasOperatorFilter())
    @$el.find('#teams').toggle(@_hasTeamsFilter())
    @$el.find('#analysis-ranges').toggle(@_hasRangeSelector())
    @$el.find('#work-calendar').toggle(@_hasWorkCalendarCheck())
    @$el.find('#include-profile-attributes').toggle(@_hasProfileAttributesCheck())
    @$el.find('.date-from-input, .date-to-input').toggleClass('with-time', @_hasTimeSelector())
    @teamSelectorView.setHasGeneralActivity(@_hasGeneralActivityTeam())
    @togglePeriodSelector()

  _isReportWithFilter: ->
    not @_isSpecialReport() and not @_hasTeamsFilter()

  _isSpecialReport: ->
    @specialReportKeys.indexOf(@_currentReport()) > -1

  _hasOperatorFilter: ->
    @reportsWithOperatorFilter.indexOf(@_currentReport()) > -1

  _hasTeamsFilter: ->
    @reportsWithTeamsFilter.indexOf(@_currentReport()) > -1

  _hasGeneralActivityTeam: ->
    @reportsWithGeneralActivityTeam.indexOf(@_currentReport()) > -1

  _hasRangeSelector: ->
    @reportsWithRangeSelector.indexOf(@_currentReport()) > -1

  _hasWorkCalendarCheck: ->
    @reportsWithWorkCalendarCheck.indexOf(@_currentReport()) > -1

  _hasProfileAttributesCheck: ->
    @reportsWithProfileAttributesCheck.indexOf(@_currentReport()) > -1

  _hasTimeSelector: ->
    @reportsWithTimeSelector.indexOf(@_currentReport()) > -1

  togglePeriodSelector: ->
    @$el.find('#rd_created').prop("checked", true);
    if @_hasPeriodSelector()
      @$el.find('.activity-options').show()
    else
      @$el.find('.activity-options').hide()

  _hasPeriodSelector: ->
    selected = _.str.underscored(@$el.find('#report option:selected').text())
    @reportsWithPeriodSelector.indexOf(selected) > -1

  _currentReport: ->
    @$el.find('#report').val()

  onChangeFilter: (event) =>
    @$el.find('#content').hide()
    @successfulJobId = undefined

  filter: (event) =>
    event.preventDefault()
    @$el.addClass('processing')
    @_doRequest('json', @renderReportCallback)

  download: (event) =>
    event.preventDefault()
    @$el.addClass('processing')
    return @_showDaysLimitError() unless @_isValid()
    $.ajax
      type: 'POST',
      url: '/customer/reports/info_before_execution',
      data: @_reportOptions(),
      timeout: 60000,
      success: (response) =>
        @$el.removeClass('processing')
        if response.timeout
          @showModalTimeout()
        else
          @showModal(response.steps, response.estimated_time)
      error: (response) =>
        @$el.removeClass('processing')
        @showModalTimeout()

  showModal: (contentAmount, estimatedTime) =>
    modal = new Customer.Reports.ExportModalView({contentAmount: contentAmount, estimatedTime: estimatedTime})
    @$el.append modal.render().el
    modal.show()

  showModalTimeout: () =>
    modal = new Customer.Reports.ExportModalView({timeout: true})
    @$el.append modal.render().el
    modal.show()

  exportConfirm: =>
    @$el.addClass('processing')
    type = @$el.find('#report').val()
    @_doExportRequest(@output_format_definition.getFormat(type), @_alertSuccess)
    if @_isSpecialReport()
      @eventAggregator.trigger('customer:reports:export', @$el.find('#report option:selected').text())

  _alertSuccess: =>
    @$el.removeClass('processing')
    swal
      title: I18n.t 'customer.reports.modal.export_started_title'
      text: I18n.t 'customer.reports.modal.export_started_message'
      type: 'info'
      html: true

  _doExportRequest: (format, success) ->
    $.ajax
      type: 'POST',
      url: '/customer/reports/export',
      data: @_reportOptions(format),
      global: false,
      success: success
      error: @requestError

  _doRequest: (format, success) ->
    job = new ResqueJob
      url: '/customer/reports/export'
      data: @_reportOptions(format)
      success: success
      error: @requestError
    job.start()

  requestError: =>
    alert('We are sorry, but something went wrong. Please try again.')
    @$el.removeClass('processing')

  _reportOptions: (format) ->
    report_key: @$el.find('#report').val()
    date_since: @$el.find('#from').val()
    time_since: @$el.find('#time-since').val()
    date_until: @$el.find('#to').val()
    time_until: @$el.find('#time-until').val()
    activity_include: $("input[name='activity_include']:checked").val();
    timezone: @timezoneSelectorView.getSelectedTimeZone()
    previous_job_id: @successfulJobId
    output_format: format
    filters: @_reportFilters() if @_isSpecialReport()
    optional_filters: @_optionalReportFilters()

  _reportFilters: ->
    groups: @$el.find('#groups').val()
    subtypes: @$el.find('#subtypes').val()
    operators: @$el.find('#operators-filter').val() if @_hasOperatorFilter()

  _optionalReportFilters: ->
    date_range: @_dateRangeSelected()
    team: @_teamSelected()
    work_calendar: @_workCalendarSelected()
    profile_attributes: @_profileAttributesSelected()

  _dateRangeSelected: =>
    @$el.find('#analysis-range-selector').val() if @_hasRangeSelector()

  _teamSelected: =>
    @$el.find('#teams-filter').val() if @_hasTeamsFilter()

  _workCalendarSelected: =>
    @workCalendar if @_hasWorkCalendarCheck()

  _profileAttributesSelected: =>
    @profileAttributes if @_hasProfileAttributesCheck()

  renderReportCallback: (results, jobId) =>
    json = results.raw # see CustomerReportJob
    @successfulJobId = jobId
    @_convertStringsToDate(json)
    @$el.find('#content').show()
    @$el.removeClass('processing')
    @$el.find('#chart').html('')
    chart = new Customer.Reports.ChartFactory(json, @$el.find('#chart').get(0)).create()
    chart.render()
    @$el.find('#chart .content').css(padding: 0) # TODO: google charts' table have a class called "content", so a padding is added

  donwloadReportCallback: (results, jobId) =>
    @successfulJobId = jobId
    @$el.removeClass('processing')
    window.location = results.file_link # see CustomerReportJob

  render: ->
    @$el.html @template
      reports: @reports
      groups: @groups
      subtypes: @subtypes
      operators: @operators
      teams: @teams
      dateRanges: @dateRanges()
      currentAccountId: Keepcon.currentAccount.id
    @$el.find('#filter').attr('disabled', true) unless @options.reports.length > 0
    @$el.find('#content').hide()
    @_renderDatepickers()
    @_renderTimezoneSelector()
    @_renderTeamsSelector()
    @_toggleSpecificReportOptions()
    this

  _renderDatepickers: ->
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    @$el.find('.datepicker').datepicker
      todayBtn: 'linked'
      autoclose: true
      startDate: threeYearsAgo
    @$el.find('#from_datepicker').datepicker('update', moment().subtract('weeks', 1).toDate().format('DD-MM-YYYY'))
    @$el.find('#to_datepicker').datepicker('update', new Date().format('DD-MM-YYYY'))
    @$el.find('#time-until').val(moment().format('HH:mm'))

  _renderTimezoneSelector: ->
    @timezoneSelectorView = new Monitoring.Views.TimeZoneSelectorView()
    @$el.find('#timezone_selector').html(@timezoneSelectorView.render().el)

  _renderTeamsSelector: ->
    @$el.find("#teams").html(@teamSelectorView.render().el)
    @$el.find('#teams-filter').chosen()

  _convertStringsToDate: (json) ->
    (row[column] = new Date row[column] for row in json.data for column in @_columnsWithDateTypes(json.types))

  _columnsWithDateTypes: (types) ->
    index for type, index in types when type in ['date', 'datetime']

  dateRanges: ->
    [
      { id: 'half_hour', name: "30 #{I18n.t('customer.reports.minutes')}" },
      { id: 'one_hour', name: "1 #{I18n.t('customer.reports.hour')}" },
      { id: 'two_hours', name: "2 #{I18n.t('customer.reports.hours')}" },
      { id: 'three_hours', name: "3 #{I18n.t('customer.reports.hours')}" },
      { id: 'four_hours', name: "4 #{I18n.t('customer.reports.hours')}" },
      { id: 'six_hours', name: "6 #{I18n.t('customer.reports.hours')}" },
      { id: 'twelve_hours', name: "12 #{I18n.t('customer.reports.hours')}" }
    ]

  activateWorkCalendar: (event) =>
    event.preventDefault()
    @$el.find("#without-work-calendar-button").removeClass("checked")
    @$el.find("#with-work-calendar-button").addClass("checked")
    @workCalendar = true

  deactivateWorkCalendar: (event) =>
    event.preventDefault()
    @$el.find("#with-work-calendar-button").removeClass("checked")
    @$el.find("#without-work-calendar-button").addClass("checked")
    @workCalendar = false

  activateProfileAttributes: (event) =>
    event.preventDefault()
    @$el.find("#without-profile-attributes-button").removeClass("checked")
    @$el.find("#with-profile-attributes-button").addClass("checked")
    @profileAttributes = true

  deactivateProfileAttributes: (event) =>
    event.preventDefault()
    @$el.find("#with-profile-attributes-button").removeClass("checked")
    @$el.find("#without-profile-attributes-button").addClass("checked")
    @profileAttributes = false

  _isValid: ->
    return true unless @_currentReport() == 'conversations'
    fromDate = @$el.find('#from_datepicker').datepicker().data('datepicker').getDate()
    untilDate = @$el.find('#to_datepicker').datepicker().data('datepicker').getDate()
    daysDiff = moment(untilDate).diff(moment(fromDate), 'days')
    daysDiff <= 31

  _showDaysLimitError: ->
    swal
      title: I18n.t('customer.reports.conversation_report.range_error.title')
      text: I18n.t('customer.reports.conversation_report.range_error.message')
      type: 'warning'
      closeOnConfirm: true
      confirmButtonText: 'Ok'
    @$el.removeClass('processing')
